export enum Formaat {
  Bedrag = 'BEDRAG',
  BedragNegatief = 'BEDRAG_NEGATIEF',
  BedragTotaal = 'BEDRAG_TOTAAL',
  Percentage = 'PERCENTAGE'
}